module.exports = __webpack_public_path__ + "static/eating-keep-up.f4671827.jpg";